export const subCompanies = {
    PHARMACY: 'PHARMACY',
    CLINIC: 'CLINIC',
    OPTICAL: 'OPTICAL',
};

export const a = 'b';
